export const SET_SOCKET = "SET_SOCKET";

export const setSocket = socket => ({
    type: SET_SOCKET,
    socket
});
